import {
  fetchFullView,
  fetchMyViewList,
  fetchSharedViewList,
  pushMyView,
  removeMyView,
  fetchMyView,
  updateMyView,
  pushViewPage,
  fetchViewPage,
  updateViewPage,
  removeViewPage,
  pushPageItem,
  pushPageBackground,
  removePageBackground,
  fetchPageItem,
  updatePageItem,
  removePageItem,
  fetchPageItemAll,
  fetchShareUser,
  pushShareUser,
  removeShareUser,
  removeShareView,
  sendBatchRequest,
  pushUserImage,
  fetchUserImages,
  fetchImageCategories,
  fetchCategoryImages,
  removeUserImage,
} from '@/api/api.APP_TARGET';
import Logger from '@/js/logger';

const FULL_VIEW_PREFIX = 'FULL_VIEW_';
// const VIEW_PREFIX = 'VIEW_';

const getMyListView = ({ commit }) => {
  return fetchMyViewList().then((l) => commit('SET_MY_LIST', l));
};

const getSharedListView = ({ commit }) => {
  return fetchSharedViewList().then((l) => commit('SET_SHARED_LIST', l));
};

const getShareFullView = ({ state, commit }, view_id) => {
  const uid = FULL_VIEW_PREFIX + view_id;
  if (state.promise[uid]) return state.promise[uid];
  const promise = fetchFullView(view_id).then((v) => {
    if (v) commit('SET_SHARED_FULL_VIEW', v);
  });
  commit('SET_PROMISE', { promise, uid });
  return promise;
};

const getMyFullView = ({ state, commit }, view_id) => {
  const uid = FULL_VIEW_PREFIX + view_id;
  if (state.promise[uid]) return state.promise[uid];
  const promise = fetchFullView(view_id).then((v) => {
    if (v) commit('SET_FULL_VIEW', v);
  });
  commit('SET_PROMISE', { promise, uid });
  return promise;
};

const addMyView = ({ commit }, { data }) => {
  return pushMyView(data).then((v) => {
    commit('SET_MY_VIEW', { body: v });
    return v.view_id;
  });
};

const getMyView = ({ commit }, view_id) => {
  // const uid = VIEW_PREFIX + view_id;
  // if (state.promise[uid]) return state.promise[uid];
  const promise = fetchMyView(view_id).then((v) =>
    commit('SET_MY_VIEW', { body: v })
  );
  // commit('SET_PROMISE', { promise, uid });
  return promise;
};

const editMyView = ({ commit }, { view_id, data }) => {
  return updateMyView(view_id, data).then((v) =>
    commit('SET_MY_VIEW', { body: v })
  );
};

const deleteMyView = ({ commit }, { view_id }) => {
  return removeMyView(view_id).then(() => {
    commit('REMOVE_MY_VIEW', { view_id });
    commit('SET_PROMISE', { promise: null, uid: FULL_VIEW_PREFIX + view_id });
    // commit('SET_PROMISE', { promise: null, uid: VIEW_PREFIX + view_id });
  });
};

const addViewPage = ({ commit }, { view_id, data }) => {
  return pushViewPage(view_id, data).then((p) => {
    commit('SET_VIEW_PAGE', { view_id, body: p });
    return p.page_id;
  });
};

const getViewPage = ({ commit }, { view_id, page_id }) => {
  return fetchViewPage(view_id, page_id).then((p) =>
    commit('SET_VIEW_PAGE', { view_id, body: p })
  );
};

const editViewPage = ({ commit }, { view_id, page_id, data }) => {
  return updateViewPage(view_id, page_id, data).then((p) =>
    commit('SET_VIEW_PAGE', { view_id, body: p })
  );
};

const deleteViewPage = ({ commit }, { view_id, page_id }) => {
  return removeViewPage(view_id, page_id).then(() =>
    commit('REMOVE_VIEW_PAGE', { view_id, page_id })
  );
};

const addPageItem = ({ commit }, { view_id, page_id, data }) => {
  return pushPageItem(view_id, page_id, data).then((v) => {
    commit('SET_PAGE_ITEM', { view_id, page_id, body: v });
    return v.item_id;
  });
};

const addItemList = ({ commit }, itemList) => {
  const requests = itemList.map((item) => ({
    ...pushPageItem(item.view_id, item.page_id, item.data, true),
    view_id: item.view_id,
    page_id: item.page_id,
    commit: 'SET_PAGE_ITEM',
  }));
  return sendBatchRequest(
    requests.map((el) => ({
      method: el.method,
      relative_url: el.relative_url,
      body: el.body,
    }))
  ).then((res) => {
    if (!Array.isArray(res)) {
      throw new Error(
        res && res.message ? res.message : 'INVALID_BATCH_RESPONSE'
      );
    }
    const ret = [];
    res.forEach((r, index) => {
      const req = requests[index];
      if (!req) return ret.push(null);
      const response = Object.assign({}, req, r);
      if (response?.passcode?.indexOf(response.status) !== -1) {
        Logger.info('[HTTP Batch res]', response);
        const body =
          typeof response.body === 'string'
            ? JSON.parse(response.body)
            : response.body;
        commit(response.commit, {
          view_id: response.view_id,
          page_id: response.page_id,
          body,
        });
        return ret.push(body.item_id);
      }
      return ret.push(null);
    });
    return ret;
  });
};

const addPageBackground = (
  { commit },
  { view_id, page_id, data, contentType }
) => {
  return pushPageBackground(view_id, page_id, { data, contentType }).then(
    (res) =>
      commit('UPDATE_PAGE_BACKGROUND', {
        view_id,
        page_id,
        image_url: res.page_image,
      })
  );
};

const deletePageBackground = ({ commit }, { view_id, page_id }) => {
  return removePageBackground(view_id, page_id).then(() =>
    commit('REMOVE_PAGE_BACKGROUND', { view_id, page_id })
  );
};

// eslint-disable-next-line no-empty-pattern
const addUserImage = ({}, { data, contentType }) => {
  return pushUserImage({ data, contentType });
};

const getUserImages = ({ commit }) => {
  return fetchUserImages().then((v) =>
    commit('SET_USER_IMAGES', { images: v })
  );
};

const getImageCategories = ({ commit }) => {
  return fetchImageCategories().then((v) =>
    commit('SET_IMAGE_CATEGORIES', { categories: v })
  );
};

const getCategoryImages = ({ commit }, category_id) => {
  return fetchCategoryImages(category_id).then((v) =>
    commit('SET_CATEGORY_IMAGES', { images: v, category_id })
  );
};

const deleteUserImage = ({ commit, state }, imageId) => {
  commit('SET_USER_IMAGES', {
    images: state.images.USER.filter((img) => img.image_id !== imageId),
  });
  return removeUserImage(imageId);
};

const editPageItem = ({ commit }, { view_id, page_id, item_id, data }) => {
  return updatePageItem(view_id, page_id, item_id, data).then((v) =>
    commit('SET_PAGE_ITEM', { view_id, page_id, body: v })
  );
};

const getPageItem = ({ commit }, { view_id, page_id, item_id }) => {
  return fetchPageItem(view_id, page_id, item_id).then((v) =>
    commit('SET_PAGE_ITEM', { view_id, page_id, body: v })
  );
};

const getPageItemAll = ({ commit }, { view_id, page_id }) => {
  return fetchPageItemAll(view_id, page_id).then((v) =>
    commit('SET_PAGE_ITEM_ALL', { view_id, page_id, body: v })
  );
};

const deletePageItem = ({ commit }, { view_id, page_id, item_id }) => {
  return removePageItem(view_id, page_id, item_id).then(() =>
    commit('REMOVE_PAGE_ITEM', { view_id, page_id, item_id })
  );
};

const getShareUser = ({ commit }, { view_id }) => {
  return fetchShareUser(view_id).then((u) =>
    commit('SET_SHARE_USER', { view_id, body: u })
  );
};

const addShareUser = ({ commit }, { view_id, data }) => {
  return pushShareUser(view_id, data).then((u) =>
    commit('SET_SHARE_USER', { view_id, body: u })
  );
};

const deleteShareUser = ({ commit }, { view_id, share_id }) => {
  return removeShareUser(view_id, share_id).then(() =>
    commit('REMOVE_SHARE_USER', { view_id, share_id })
  );
};

const deleteShareView = ({ commit }, { view_id, share_id }) => {
  return removeShareView(view_id, share_id).then(() =>
    commit('REMOVE_SHARE_VIEW', { view_id })
  );
};

const getBatchShareUser = ({ commit }, viewList) => {
  if (!viewList.length) return;
  const requests = viewList.map((view) => ({
    ...fetchShareUser(view.view_id, true),
    view_id: view.view_id,
    commit: 'SET_SHARE_USER',
  }));
  return sendBatchRequest(
    requests.map((el) => ({
      method: el.method,
      relative_url: el.relative_url,
      body: el.body,
    }))
  ).then((res) => {
    if (!Array.isArray(res)) {
      throw new Error(
        res && res.message ? res.message : 'INVALID_BATCH_RESPONSE'
      );
    }
    res.forEach((r) => {
      const req = requests.find(
        (request) => request.relative_url === r.relative_url
      );
      if (!req) return;
      const response = Object.assign({}, req, r);
      if (response?.passcode?.indexOf(response.status) !== -1) {
        Logger.info('[HTTP Batch res]', response);
        const body =
          typeof response.body === 'string'
            ? JSON.parse(response.body)
            : response.body;
        commit(response.commit, {
          view_id: response.view_id,
          body,
        });
      }
    });
  });
};

const sendBatchUpdate = ({ commit }, payload) => {
  const {
    UPDATE_VIEW,
    DELETE_PAGE,
    UPDATE_PAGE,
    DELETE_ITEM,
    UPDATE_ITEM,
    length,
  } = payload;
  if (!length) return;
  const requests = [];

  UPDATE_VIEW.forEach(({ view_id, data }) => {
    const req = {
      ...updateMyView(view_id, data, true),
      commit: 'SET_MY_VIEW',
      view_id,
    };
    requests.push(req);
  });

  DELETE_PAGE.forEach(({ view_id, page_id }) => {
    const req = {
      ...removeViewPage(view_id, page_id, true),
      commit: 'REMOVE_VIEW_PAGE',
      view_id,
      page_id,
    };
    requests.push(req);
  });

  UPDATE_PAGE.forEach(({ view_id, page_id, data }) => {
    const req = {
      ...updateViewPage(view_id, page_id, data, true),
      commit: 'SET_VIEW_PAGE',
      view_id,
      page_id,
    };
    requests.push(req);
  });

  DELETE_ITEM.forEach(({ view_id, page_id, item_id }) => {
    const req = {
      ...removePageItem(view_id, page_id, item_id, true),
      commit: 'REMOVE_PAGE_ITEM',
      view_id,
      page_id,
      item_id,
    };
    requests.push(req);
  });

  UPDATE_ITEM.forEach(({ view_id, page_id, item_id, data }) => {
    const req = {
      ...updatePageItem(view_id, page_id, item_id, data, true),
      commit: 'SET_PAGE_ITEM',
      view_id,
      page_id,
      item_id,
    };
    requests.push(req);
  });

  return sendBatchRequest(
    requests.map((el) => ({
      method: el.method,
      relative_url: el.relative_url,
      body: el.body,
    }))
  ).then((res) => {
    if (!Array.isArray(res)) {
      throw new Error(
        res && res.message ? res.message : 'INVALID_BATCH_RESPONSE'
      );
    }
    res.forEach((r) => {
      const req = requests.find(
        (request) => request.relative_url === r.relative_url
      );
      if (!req) return;
      const response = Object.assign({}, req, r);
      if (typeof r.body === 'string') {
        response.body = JSON.parse(r.body);
      }
      if (response.passcode.indexOf(response.status) !== -1) {
        Logger.info('[HTTP Batch res]', response);
        commit(response.commit, response);
      }
    });
  });
};

export default {
  getMyListView,
  getSharedListView,
  getMyFullView,
  addMyView,
  getMyView,
  editMyView,
  deleteMyView,
  addViewPage,
  getViewPage,
  editViewPage,
  deleteViewPage,
  addPageItem,
  addItemList,
  editPageItem,
  getPageItem,
  getPageItemAll,
  deletePageItem,
  getShareUser,
  addShareUser,
  deleteShareUser,
  deleteShareView,
  sendBatchUpdate,
  getShareFullView,
  addPageBackground,
  deletePageBackground,
  getBatchShareUser,
  addUserImage,
  getUserImages,
  deleteUserImage,
  getImageCategories,
  getCategoryImages,
};
